const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/feed_.welcome.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
// Mobile-only: on desktop the banner is always shown in full on the feed.

export const Route = createFileRoute("/feed_/welcome")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});